import { TokenRow, TokenSelectItem } from '@/app/components/Modal/TokenRow';
import { cn } from '@/app/shared/lib/cn';

type TokenSelectListProps = {
  tokens: TokenSelectItem[];
  selectedToken?: string;
  onSelect: (token: TokenSelectItem) => void;
  className?: string;
};

export const TokenSelectList = ({
  tokens,
  selectedToken,
  onSelect,
  className,
}: TokenSelectListProps) => (
  <div className={cn('flex flex-col gap-[3px]', className)} role='listbox'>
    {tokens.map((token) => (
      <TokenRow
        key={token.address}
        token={token}
        isSelected={token.address.toLowerCase() === selectedToken?.toLowerCase()}
        onClick={() => onSelect(token)}
      />
    ))}
  </div>
);
